import qs from 'qs';
import { ReportApi } from './externalApi';

export class ReportingService {
  static listAllCommissions(query: string) {
    const options = qs.parse(query);
    return ReportApi(process.env.VUE_APP_REPORTING_BASE_URL).get(`/transactions/commissions${query ? query : ''}`, {
      responseType: options?.download ? 'blob' : 'json',
    });
  }

  static analyticsDailySuccessful(query: string) {
    return ReportApi(process.env.VUE_APP_REPORTING_BASE_URL).get(
      `/analytics/transactions/daily-successful${query || ''}`,
    );
  }

  static analyticsTopOrganizations(query: string) {
    return ReportApi(process.env.VUE_APP_REPORTING_BASE_URL).get(`/analytics/organizations/top${query || ''}`);
  }

  static analyticsDailyOverview(query: string) {
    return ReportApi(process.env.VUE_APP_REPORTING_BASE_URL).get(
      `/analytics/transactions/daily-overview${query || ''}`,
    );
  }
}
